import {styled} from '@mui/material';

const StyledFinishedContainer = styled('div')(({theme}) => ({
	padding: 16,
	paddingBottom: 72,
	display: 'flex',
	flexDirection: 'column',
	gap: 24,
	[theme.breakpoints.up('sm')]: {
		padding: 32,
		paddingBottom: 32,
		display: 'grid',
		gridTemplateColumns: 'auto 312px',
		gap: 24,
	},
}));

const ProceduresContainer = styled('div')(({theme}) => ({
	width: '100%',
	margin: '0 auto',
	borderRadius: '8px',
	backgroundColor: theme.palette.background.paper,
	display: 'flex',
	flexDirection: 'column',
	gap: '16px',
}));

export {StyledFinishedContainer, ProceduresContainer};
